/**
 * Vue 2.7's observable() is not constructable with `new` in native ESM (Vite).
 * @webqam/vue-match-media and legacy code use `new Vue.observable(...)`.
 */
export function patchVueObservable(Vue) {
  if (!Vue?.observable || Vue.observable.__lgfPatched) {
    return;
  }

  const observable = Vue.observable.bind(Vue);

  Vue.observable = function (obj) {
    return observable(obj);
  };
  Vue.observable.__lgfPatched = true;
}
